import React, { useEffect, useState } from 'react';
import PopupKitchenCard from './popup-kitchen-card';
import PageText from 'components/base/page-text';
import { CoKitchenType } from 'utils/types';
import useDashboardContext from 'contexts/dashboard.context';

const PopupKitchenList = () => {
  const { searchValue, cokitchens } = useDashboardContext();
  const [filteredCokitchens, setFilteredCokitchens] = useState<CoKitchenType[]>([]);

  useEffect(() => {
    if (!searchValue) {
      setFilteredCokitchens(cokitchens.filter((item) => item.cokitchen_type === 'pop'));
      return;
    }
    setFilteredCokitchens(
      cokitchens.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()))
    );
  }, [searchValue, cokitchens]);

  return (
    <div>
      {filteredCokitchens?.length === 0 ? (
        <PageText
          text={
            searchValue
              ? 'No pop-up kitchens match your searchValue'
              : 'No Pop up kitchens available'
          }
        />
      ) : (
        <div className='grid md:grid-cols-3 grid-cols-4 gap-6'>
          {filteredCokitchens?.map((item: any, index: number) => (
            <PopupKitchenCard key={index} data={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PopupKitchenList;
